import React, { useState } from 'react';

import { BASE_PATH } from 'shared/constants';

interface ImageWithFallbackProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

export const DEFAULT_FALLBACK_IMAGE_PATH = `${BASE_PATH}/static/assets/fallback/no-image.svg`;

const ImageWithFallback = ({
  src,
  alt,
  fallbackSrc = DEFAULT_FALLBACK_IMAGE_PATH,
  ...rest
}: ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <img
      {...rest}
      alt={alt}
      src={imgSrc}
      onError={() => setImgSrc(fallbackSrc)}
    />
  );
};

export default ImageWithFallback;
